import React, { useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import PaymentAcceptImage from "../../assets/images/commingSoonEn.png";
import "react-toastify/dist/ReactToastify.css";
import "./ComSoonEn.scss";
import "./Responsive.scss";

const ComSoonEn = (props) => {
  useEffect(() => {
    Config.pageUp();
  }, []);

  return (
    <section className="paymentWrapper mobile">
      <Helmet>
        <title>{Config.helmetTitle}</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="paymentContents">
        <div className="desktop">
          <div className="paymentFigure">
            <img src={PaymentAcceptImage} className="paymentImage" alt="comming soon" />
            <Link className="return" to="/">
              بازگشت به صفحه اصلی
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(withRouter(ComSoonEn));
